import api from './api';
import { Unit, CreateUnitData, UnitFilters } from '../types/unit';

export const unitService = {
  getAll: async (
    workspaceId: string,
    params?: UnitFilters & { page?: number; limit?: number }
  ) => {
    const response = await api.get(
      `/workspaces/${workspaceId}/units`,
      { params }
    );
    return response.data;
  },

  getById: async (workspaceId: string, id: string) => {
    const response = await api.get(
      `/workspaces/${workspaceId}/units/${id}`
    );
    return response.data;
  },

  create: async (workspaceId: string, data: CreateUnitData) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/units`,
      data
    );
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: Partial<CreateUnitData>) => {
    const response = await api.put(
      `/workspaces/${workspaceId}/units/${id}`,
      data
    );
    return response.data;
  },

  delete: async (workspaceId: string, id: string) => {
    const response = await api.delete(
      `/workspaces/${workspaceId}/units/${id}`
    );
    return response.data;
  },

  getByProject: async (
    workspaceId: string,
    projectId: string,
    params?: UnitFilters & { page?: number; limit?: number }
  ) => {
    const response = await api.get(
      `/workspaces/${workspaceId}/projects/${projectId}/units`,
      { params }
    );
    return response.data;
  }
};
